const version = "4.4.4";

export default version;
